import Navbar from "@/Components/Navbar"
import { useNavigate, useParams } from "react-router-dom"
import backgroundImage from "@/images/backgrounds/lobby-background.webp"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { getUserCreds, socket } from "@/utils/utils"
import Rank from "@/Components/Rank"
import rankImage from "@/images/rank.webp"
import rollBtnBackground from "@/images/roll-button.webp"

import MoneyAnimation from "@/Components/MoneyAnimation"
import TradePropertyPanel from "../Trade/TradePropertyPanel"
import counterButtonBg from "@/images/trade-counter-btn.webp"
import acceptButtonBg from "@/images/trade-accept-btn.webp"
import declineButtonBg from "@/images/trade-decline-btn.webp"
import offerButtonBg from "@/images/trade-offer-btn.webp"
import dummyMiniMonopolyImage from "@/images/mini-monopoly-image.webp"
import ButtonWithBacground from "@/Components/ButtonWithBackground"
import Board from "../Game/Board"
import MiniBoard from "../Trade/MiniBoard"
import {
  getCellByOrderAndMapId,
  getCurrentPlayer,
  getPlayerByPlayerOrder,
} from "@/utils/gameHelpers"
import mrMonopolyWaiting from "@/images/mr-monopoly/waiting.png"
import mrMonopolyOffering from "@/images/mr-monopoly/offering.png"
import mrMonopolyCreatingOffer from "@/images/mr-monopoly/creating-offer.png"
import mrMonopolySad from "@/images/mr-monopoly/sad.png"
import mrMonopolyAccepting from "@/images/mr-monopoly/accepting.png"
import { Audio, Blocks, Hourglass, ThreeDots } from "react-loader-spinner"
import PropertyBidCard from "@/Components/PropertyBigCard"
import { mapDesigns } from "@mono/mapDesigns"
import HighestBigCard from "./HighestBidCard"
import PlayerListItem from "../Game/PlayerListItem"
import PlayerListItemInfo from "../Game/PlayerListItemInfo"
import AuctionPlayerItem from "./AuctionPlayerItem"
import { dummyPlayers, dummyUsers, minBidDifference } from "@/utils/data"
import Stepper from "@/Components/Stepper"
import TradeMoneySlider from "../Trade/TradeMoneySlider"
import classNames from "classnames"
import { getHighestBidder } from "@/utils/auctionHelpers"
import Timer, { TimerRef } from "./Timer"
import { dividePriceIntoBills } from "@/utils/animationHelpers"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setState, setModalData } from "@/store/globalSlice"

interface NewGameProps {}

interface BidFlyingText {
  playerOrder: number
  bid: number
}
const Auction: React.FC = () => {
  const myGame = useAppSelector((state) => state.global.myGame)
  const dispatch = useAppDispatch()

  const myMap = mapDesigns.find((map) => map.id === myGame?.settings.mapId)
  const auctionedProperty = getCellByOrderAndMapId(
    myGame?.situation?.activeAuctionPropertyOrder || 0,
    myGame?.settings.mapId || ""
  )
  if (!auctionedProperty) return null
  const myGroup = myMap?.groups.find(
    (group) => group.id === auctionedProperty.propertyDetails?.groupId
  )
  const [activeIndex, setActiveIndex] = useState(0)
  const players = myGame?.situation?.players

  const users = myGame!.players
  const currentPlayer = getCurrentPlayer(myGame as IGameDetails)
  const highestBidder = getHighestBidder(myGame?.situation?.players)

  const highestBid = highestBidder?.auctionData?.bid || 0
  // const minAllowedBid = highestBid + minBidDifference || 0
  const minAllowedBid = 0
  const maxAllowedBid = currentPlayer?.money || 0
  const [myBidValue, setMyBidValue] = useState(minAllowedBid)
  const [bidFlyingTexts, setBidFlyingTexts] = useState<BidFlyingText[]>([])
  const timerRef = useRef<TimerRef>(null)

  const [madeBid, setMadeBid] = useState(false)
  const resetTimer = () => {
    if (timerRef.current) {
      timerRef.current.resetTimer() // Call resetTimer from the Timer component
    }
  }

  const nav = useNavigate()

  const bids = players?.map((player) => ({
    order: player.order,
    bid: player.auctionData?.bid,
  }))

  useEffect(() => {
    setMyBidValue(minAllowedBid)
  }, [minAllowedBid])

  const handleClickOnBid = () => {
    setMadeBid(true)
    // resetTimer()
    socket.emit("auction.response", {
      roomid: myGame!.id,
      playerOrder: currentPlayer!.order as PlayerOrder,
      bidValue: myBidValue as number,
    })
    // socket.emit(
    //   "auction.bid",
    //   state.myGame!.id,
    //   myBidValue,
    //   currentPlayer!.order
    // )
  }

  const handleWithdrawingFromBidding = () => {
    setMadeBid(true)

    socket.emit("auction.response", {
      roomid: myGame!.id,
      playerOrder: currentPlayer!.order as PlayerOrder,
      bidValue: 0,
    })
    // socket.emit(
    //   "auction.withdraw-from-bidding",
    //   state.myGame!.id,
    //   currentPlayer!.order
    // )
    resetTimer()
  }
  const handlePassBid = () => {
    socket.emit("auction.pass-turn", myGame!.id, currentPlayer!.order)
  }
  useEffect(() => {
    if (myGame?.situation?.activeAuctionPropertyOrder === null) {
      dispatch(setModalData({ auction: { visible: false } }))
    }
  }, [myGame?.situation?.activeAuctionPropertyOrder, dispatch])
  useEffect(() => {
    if (
      bidFlyingTexts.some((bidFlyText) => bidFlyText.bid !== highestBid) &&
      highestBidder
    ) {
      setBidFlyingTexts([
        ...bidFlyingTexts,
        { bid: highestBid, playerOrder: highestBidder.order },
      ])
    }
  }, [highestBid, bidFlyingTexts, highestBidder])
  if (myGame?.situation?.activeAuctionPropertyOrder === null) {
    return null
  }
  if (!currentPlayer) return null
  if (!myGame?.situation?.activeAuctionPropertyOrder) return null
  const unableToBidMore = minAllowedBid > currentPlayer?.money
  if (!myGame) return null
  const cell = getCellByOrderAndMapId(
    myGame.situation!.activeAuctionPropertyOrder,
    myGame.settings.mapId
  )
  return null
  return (
    <div
      data-testid="trade"
      className="w-screen h-screen bg-cover grid grid-cols-2 px-28 pt-10 pb-10 fixed top-0 left-0 z-[100]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="flex flex-col   h-full w-full justify-between relative">
        <div className="flex gap-1 font-poppins text-2xl uppercase">
          <div className="text-white">auction at</div>
          <div className="font-semibold" style={{ color: myGroup?.color }}>
            {auctionedProperty?.propertyDetails?.name}
          </div>
        </div>
        <div className="flex justify-center items-center gap-2 text-white font-poppins text-xl">
          <div className="bg-auction-timerBackground px-4 py-2 rounded">
            Rounds Left: {myGame?.situation?.auctionRoundsLeft || 3}
          </div>
        </div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2   flex w-full justify-center">
          <PropertyBidCard cell={cell as ICell}></PropertyBidCard>
        </div>
      </div>
      <div className="flex flex-col justify-start bg-trade-panelBackground p-4  gap-4">
        <div className="flex flex-col gap-4 flex-grow">
          {users.map((user, i) => {
            const player = players!.find((x) => x.id === user.email) as IPlayer

            return (
              <>
                <div key={player.order} onClick={() => setActiveIndex(i)}>
                  <AuctionPlayerItem
                    key={player.order}
                    player={player}
                    user={user}
                    bid={0}
                    activeBidding={player.auctionData?.active}
                    isHighestBidder={player.order === highestBidder?.order}
                    isBidding
                  ></AuctionPlayerItem>
                </div>
              </>
            )
          })}
        </div>
        <div className="flex w-full justify-between items-center mb-10">
          <div className="flex flex-col gap-4 w-full justify-center">
            <div className="">
              {unableToBidMore ? null : (
                <TradeMoneySlider
                  max={maxAllowedBid}
                  value={myBidValue}
                  setValue={setMyBidValue}
                  min={0}
                  minTestId="auction.money-slider-min"
                  maxTestId="auction.money-slider-max"
                ></TradeMoneySlider>
              )}
            </div>
            {
              <div className="flex justify-between w-full items-end px-8">
                <div className="flex gap-4 items-center">
                  {madeBid ? null : (
                    <button
                      className={classNames(
                        "roll w-36 relative text-2xl  bg-contain text-[#531F49] font-poppins font-semibold h-full "
                      )}
                      data-testid="auction.bid-btn"
                      onClick={handleClickOnBid}
                    >
                      <img
                        src={rollBtnBackground}
                        className="h-full w-full object-contain"
                      ></img>
                      <div
                        className={classNames(
                          "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/3"
                        )}
                      >
                        Bid
                      </div>
                    </button>
                  )}
                  {/* <button
                    className={classNames(
                      "roll w-36 relative text-2xl  bg-contain text-[#531F49] font-poppins font-semibold h-full "
                    )}
                    data-testid="auction.pass-btn"
                    onClick={handlePassBid}
                  >
                    <img
                      src={rollBtnBackground}
                      className="h-full w-full object-contain"
                    ></img>
                    <div
                      className={classNames(
                        "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/3"
                      )}
                    >
                      Pass
                    </div>
                  </button> */}
                  <button
                    className={classNames(
                      "roll w-36 relative text-2xl  bg-contain text-[#531F49] font-poppins font-semibold h-full "
                    )}
                    // onClick={onClickOnRoll}
                    data-testid="auction.withdraw-btn"
                    onClick={handleWithdrawingFromBidding}
                  >
                    <img
                      src={rollBtnBackground}
                      className="h-full w-full object-contain"
                    ></img>
                    <div
                      className={classNames(
                        "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/3"
                      )}
                    >
                      Withdraw
                    </div>
                  </button>
                </div>

                <Timer
                  onTimeout={() => {}}
                  ref={timerRef}
                  initialTime={15}
                  totalTime={15}
                  onChange={(value) => {}}
                />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}
export default Auction
